module.exports = __webpack_public_path__ + "img/sponsorS13.f35f75e1.png";